import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import AppRoutes from "./routes/AppRoutes";
import FootPrintModal from "./components/common/FootPrintModal";
// import PolicyModal from "./components/common/PolicyModal";
import { useRequestProcessor } from "./requestProcessor";
import { fetchConstants } from "./queryfunctions/queryfunctions";
import FootprintNotification from "./components/common/FootprintNotification";
import { sendUnsentReports, setEnabled } from "./crashlyticsMethods";
import { setupAxiosMonitoring } from "./monitoring/setupAxiosMonitoring";

// import { setContext } from "./crashlyticsMethods";
// import { performSecurityCheck } from "./utils/rootDetection";
// import SecurityWarning from "./components/common/SecurityWarning";

setupAxiosMonitoring();

const App = () => {
    const { useQueryWrapper } = useRequestProcessor()
    // const [securityStatus, setSecurityStatus] = useState(null);

    useQueryWrapper(
        ["fetchConstants"],
        () => fetchConstants()
    );

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return;

        (async () => {
            try {
                await setEnabled(true);
                await sendUnsentReports();
            } catch (e) {
                console.warn("Crashlytics initialization failed", e);
            }
        })();
    }, []);

    // Secondary root check via @capgo/capacitor-is-root (JS layer).
    // Primary checks (root, Frida, dev options) already run natively
    // in MainActivity.onCreate before this WebView loads.
    // useEffect(() => {
    //     if (!Capacitor.isNativePlatform()) return;

    //     (async () => {
    //         try {
    //             const result = await performSecurityCheck();
    //             setSecurityStatus(result);

    //             if (!result.isSecure) {
    //                 try {
    //                     await setContext("SecurityStatus", JSON.stringify({
    //                         isSecure: false,
    //                         ...result.status,
    //                         timestamp: new Date().toISOString(),
    //                     }));
    //                 } catch (e) {
    //                     console.warn("Failed to log security status to crashlytics", e);
    //                 }
    //             }
    //         } catch (e) {
    //             console.error("Security check failed:", e);
    //             setSecurityStatus({ isSecure: false, status: { error: e.message } });
    //         }
    //     })();
    // }, []);

    return (
        <Router>
            <FootPrintModal />
            <FootprintNotification />
            {/* <PolicyModal /> */}
            {/* <SecurityWarning securityStatus={securityStatus} blockAccess={true} /> */}
            <AppRoutes />
        </Router>
    );
};

export default App;
